import React, { useMemo, useEffect, useRef, useState } from 'react'
import { StyleElement } from '../../Main/StyleElement'
import { formatThemeStyleText } from '../../../constants/addStyleClasses'
import { DEFAULT_LOADERS } from '../../../constants/DEFAULT_LOADERS'
import { useSelector } from 'react-redux'
import { Map } from 'immutable'
import { useLangDirection } from '../../../hooks/useLangDirection'

function ProjectThemeStyleComponent({ mode, stripRoot, isPreview, useSmartV, themeStyles = [] }) {
  const theme = useSelector((state) => state.getIn(['project', 'Settings', 'theme'], Map()) || Map())
  const isRTL = useLangDirection()
  const [style, setStyle] = useState(() => {
    let currentTheme = theme
    if (!currentTheme.hasIn(['lg', 'CustomLoader', 'loader', 'backgroundImage'])) {
      currentTheme = currentTheme.setIn(['lg', 'CustomLoader', 'loader', 'backgroundImage'], DEFAULT_LOADERS[0].path)
    }
    if (!currentTheme.getIn(['lg', 'sfPreloaderMsg', 'icon', 'backgroundImage'])) {
      currentTheme = currentTheme.setIn(['lg', 'sfPreloaderMsg', 'icon', 'backgroundImage'], DEFAULT_LOADERS[0].path)
    }
    if (!themeStyles.includes('FormField')) {
      currentTheme = currentTheme.delete('FormField')
    }
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'height'], '100')
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'heightUnit'], '%')
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'width'], stripRoot[mode])
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'widthUnit'], 'px')
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'position'], 'relative')
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'left'], '50')
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'leftUnit'], '%')
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'transform'], 'translateX(-50%)')
    if (!isPreview) {
      currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'marginLeft'], '-15')
      currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'marginLeftUnit'], 'px')
    }
    currentTheme = currentTheme.set(
      'lg',
      currentTheme.get('lg', Map()).filter((v, k) => themeStyles.includes(k))
    )
    return formatThemeStyleText('ft--theme', currentTheme, mode, stripRoot, isRTL, isPreview)
  })

  useEffect(() => {
    let currentTheme = theme
    if (!currentTheme.hasIn(['lg', 'CustomLoader', 'loader', 'backgroundImage'])) {
      currentTheme = currentTheme.setIn(['lg', 'CustomLoader', 'loader', 'backgroundImage'], DEFAULT_LOADERS[0].path)
    }
    if (!currentTheme.getIn(['lg', 'sfPreloaderMsg', 'icon', 'backgroundImage'])) {
      currentTheme = currentTheme.setIn(['lg', 'sfPreloaderMsg', 'icon', 'backgroundImage'], DEFAULT_LOADERS[0].path)
    }
    if (!themeStyles.includes('FormField')) {
      currentTheme = currentTheme.delete('FormField')
    }
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'height'], '100')
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'heightUnit'], '%')
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'width'], stripRoot[mode])
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'widthUnit'], 'px')
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'position'], 'relative')
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'left'], '50')
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'leftUnit'], '%')
    currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'transform'], 'translateX(-50%)')
    if (!isPreview) {
      currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'marginLeft'], '-15')
      currentTheme = currentTheme.setIn(['lg', 'CarouselContainer', 'contentRoot', 'marginLeftUnit'], 'px')
    }
    currentTheme = currentTheme.set(
      'lg',
      currentTheme.get('lg', Map()).filter((v, k) => themeStyles.includes(k))
    )
    let allowApply = true
    if (typeof window?.__FT__BUILDER_API__?.workerTask === 'function') {
      window.__FT__BUILDER_API__
        .workerTask('theme', 'ft--theme', currentTheme, mode, stripRoot, isRTL, isPreview)
        .then((style) => {
          if (allowApply) {
            if (style) {
              setStyle(style)
            } else {
              setStyle(formatThemeStyleText('ft--theme', currentTheme, mode, stripRoot, isRTL, isPreview))
            }
          }
        })
        .catch((error) => {
          console.error(error)
          setStyle(formatThemeStyleText('ft--theme', currentTheme, mode, stripRoot, isRTL, isPreview))
        })
    } else {
      setStyle(formatThemeStyleText('ft--theme', currentTheme, mode, stripRoot, isRTL, isPreview))
    }
    return () => {
      allowApply = false
    }
  }, [theme, mode, stripRoot, isPreview, isRTL, themeStyles])

  return <StyleElement uid="theme" style={style} />
}

export const ProjectThemeStyle = React.memo(ProjectThemeStyleComponent)
